import { ApiClient } from '@webapp/core/services/ApiClient'
import { CardholderRepository } from './CardholderRepository'

export const cardholderRepository = new CardholderRepository({
  httpClient: ApiClient,
})
